import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import PageViewActionHoc from '../../../Event/PageViewActionHoc';
import BlurText from '../../../Ui/Common/BlurText';
import Image from '../../../Ui/Common/Image';
class SectionArticlesDocument extends Component {
    constructor() {
        super(...arguments);
        this.onClickCell = () => {
            const { apiCreateUserPageView, isBlur, row, showPdfModal } = this.props;
            if (!isBlur) {
                if (apiCreateUserPageView) {
                    apiCreateUserPageView('related_document', 'open', row.id);
                }
                showPdfModal(row.images);
            }
        };
    }
    render() {
        const { isBlur, row } = this.props;
        return (_jsxs("div", Object.assign({ className: 'relation-link-content', onClick: this.onClickCell, role: 'presentation' }, { children: [_jsx("div", Object.assign({ className: 'is-thumbnail' }, { children: _jsx("div", { children: _jsx(Image, { allowContextMenu: false, alt: '', isBlur: isBlur, isObjectFit: true, src: row.imageUrl, useImage: true }) }) })), _jsx(BlurText, Object.assign({ className: 'relation-link-title', component: 'div', isBlur: isBlur }, { children: row.title }))] })));
    }
}
SectionArticlesDocument.propTypes = {
    apiCreateUserPageView: propFunc(),
    isBlur: propBool().isRequired,
    row: propShape().isRequired,
    showPdfModal: propFunc().isRequired,
};
SectionArticlesDocument.defaultProps = {
    apiCreateUserPageView: undefined,
};
export default PageViewActionHoc(SectionArticlesDocument);
